<template>
  <div>
    <div class="dontPrint">
      <!--      <div class="printOnly">-->
      <v-layout v-if="view !=='details'">
        <v-flex xs5 text-xs-right>
          <v-layout>
            <v-flex xs3 text-xs-left>
              <v-tooltip bottom>
                <v-btn flat icon @click="logout" slot="activator" color="grey" class="mr-0 ml-0">
                  <v-icon>exit_to_app</v-icon>
                </v-btn>
                <span>Logout</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs9 text-xs-right>
              <v-btn flat v-if="moment(date).day() !== 1" @click="getPrevious">
                <v-icon>
                  chevron_left
                </v-icon>
                Previous
              </v-btn>
              <v-btn flat v-else @click="getPrevious">
                <v-icon>
                  chevron_left
                </v-icon>
                Previous week
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs2>
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="40"
            :return-value.sync="date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <span slot="activator"><v-btn color="primary" flat round
                                          text-color="white">{{ parseDate(date) }}</v-btn></span>
            <v-date-picker :allowed-dates="allowedDates" v-model="date" no-title
                           @input="$refs.menu.save(date); initOrders(moment(date))"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs5>
          <v-layout>
            <v-flex xs8 text-xs-left>
              <v-btn flat v-if="moment(date).day() !== 0" @click="getNext">
                Next
                <v-icon>chevron_right</v-icon>
              </v-btn>
              <v-btn flat v-else @click="getNext">
                Next week
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs4 text-xs-right class="mr-2">
              <v-btn v-if="view === 'list'" flat icon @click="showLabels=!showLabels" color="black"
                     :outline="showLabels"
                     :depressed="showLabels"
                     class="mr-0 ml-0">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn flat icon @click="view = 'list'" :color="view === 'list' ? 'black' : 'grey'" class="mr-0 ml-0">
                <v-icon>view_list</v-icon>
              </v-btn>
              <v-btn flat icon @click="view = 'column'" :color="view === 'column' ? 'black' : 'grey'" class="mr-0 ml-0">
                <v-icon>view_column</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <BoxOverview :daysGroup="daysGroup" :orders="newItems" :date="date" v-if="view === 'column'"/>
      <div id="overview" v-if="view === 'list' && !showLabels">
        <v-card>
          <v-card-title>
            <div><h2 style="font-family: 'Gotham Bold';">Orders</h2></div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text v-if="!loading">
            <div class="text-xs-left">
              <strong>Shipping Date -</strong>
              {{ formatShippingDate() }}
            </div>
            <div class="text-xs-left">
              <strong>Driver Assigned - </strong>
              {{ assignedDriverCount }} of {{ newItems.length }}
            </div>
            <div class="text-xs-left" v-for="(value, day) in usersCountPerDay">
              <strong>{{ getFullDay(day) }} - </strong>
              <span v-for="(total, stream) in value">
                {{ stream }}: {{ total }}
              </span>
              <br/>
            </div>
            <v-data-table
              ref="table"
              :loading="loading"
              :headers="headers"
              :items="newItems"
              :search="search"
              :values="values"
              hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <span class="text-xs-center" v-html="props.header.text"></span>
              </template>
              <template slot="items" slot-scope="props">
                <tr @click="displayFilteredItems(props.index)">
                  <td class="text-xs-left">{{ formatDriver(props.item.driver) }}</td>
                  <td class="text-xs-left">
                    {{ props.item.name }}
                    <span v-if="props.item.bins && props.item.bins.length>0">
                      <br/>
                      <v-chip outline x-small style="font-size: smaller" v-for="(bin,i) of props.item.bins"
                              v-bind:key="i">{{ bin }} </v-chip>
                    </span>
                  </td>
                  <td class="text-xs-left">{{ props.item.company }}</td>
                  <td class="text-xs-left">{{ props.item.substitution }}</td>
                  <td class="text-xs-left">{{ streams[props.item.stream].name }}</td>
                  <td class="text-xs-left">{{ props.item.size }}</td>
                  <td class="text-xs-left">[{{ props.item.location }}] {{ props.item.comment }}</td>
                  <template v-for="day in daysGroup">
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].breakfast === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].breakfast > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{ props.item[day].breakfast }}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].lunch === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].lunch > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{ props.item[day].lunch }}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].dinner === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].dinner > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{ props.item[day].dinner }}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].custom.length === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].custom.length > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{ getCustomQuantity(props.item[day].custom) }}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                  </template>
                  <td class="justify-center layout px-0">
                    <v-btn v-if="props.item.packed" icon class="mx-0"
                           @click.stop="pack = false; packedMeals(props.item, false)">
                      <v-icon color="green">check_circle</v-icon>
                    </v-btn>
                    <v-btn v-else icon class="mx-0" @click.stop="pack = true; packedMeals(props.item, true)">
                      <v-icon color="teal">check_circle_outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
      <div v-if="$refs.table && $refs.table.filteredItems && view === 'details'">
        <order-details :daysGroup="daysGroup" :items.sync="$refs.table.filteredItems" :itemIndex="selectedItem"
                       :dayIndex="getDayIndex()" :date="date" @packed="packedMeals" @updatePack="updatePack"
                       v-on:backToOverview="view='list'"/>
      </div>
    </div>
    <div
      :class="{ printOnly : !showLabels }"
      style="background: whitesmoke"
    >
      <ShipLabel
        v-for="(item, index) in sheets.filter(s => !s.driver)"
        v-bind:key="index"
        :driver="formatDriver(item.driver)"
        :customer-name="item.name"
        :bags="item.bags"
        :bag-size="item.bagSize"
        :bins="item.bins"
        class="my-1"
      />

      <template v-for="(bagCount, driver) in drivers">
        <DriverLabel
          :driver="driver"
          :driver-id="formatDriver(driver)"
          :bagCount="bagCount"
          class="my-1"
        />
        <ShipLabel
          v-for="(item, index) in sheets.filter(s => s.driver==driver)"
          v-bind:key="index"
          :driver="formatDriver(item.driver)"
          :customer-name="item.name"
          :bags="item.bags"
          :bag-size="item.bagSize"
          :bins="item.bins"
          class="my-1"
        />
      </template>
      <!--        <div style="height: 1.5cm" class="align-center headline">-->
      <!--          <v-layout>-->
      <!--            <v-flex xs4>-->
      <!--              <div class="align-center">-->
      <!--                <strong>{{ formatDriver(item.driver) }}</strong>-->
      <!--              </div>-->
      <!--            </v-flex>-->
      <!--            <v-flex class="align-center text-xs-left" xs6>-->
      <!--              <div class="align-center">-->
      <!--                <strong>{{ item.name }}</strong>-->
      <!--              </div>-->
      <!--            </v-flex>-->
      <!--            <v-flex class="align-center text-xs-left" xs2>-->
      <!--              <div v-if="item.bags" class="align-center">-->
      <!--                <strong>{{ item.bags }}</strong>-->
      <!--              </div>-->
      <!--              <div v-if="item.bagSize === 'large'">-->
      <!--                <strong>*</strong>-->
      <!--              </div>-->
      <!--            </v-flex>-->
      <!--          </v-layout>-->
      <!--        </div>-->
      <!--        <div class="page-break" v-if="index > 0 && (((index + 1) % 13) === 0)"></div>-->
    </div>
  </div>
</template>
<script>
import firebase from 'firebase/app';
import OrderHelper from '../helpers/orderHelper';
import 'firebase/database';
import moment from 'moment';
import OrderDetails from "./partials/OrderDetails";
import BoxOverview from "@/components/BoxOverview";
import {mapGetters} from 'vuex';
import ShipLabel from './partials/ShipLabel';
import DriverLabel from './partials/DriverLabel';

const headerBase = [
  {
    text: 'Driver',
    align: 'left',
    value: 'driver',
    sortable: true
  },
  {
    text: 'Name',
    align: 'left',
    value: 'name',
    sortable: true
  },
  {
    text: 'Company',
    align: 'left',
    value: 'company',
    sortable: true
  },
  {
    text: 'Substitution',
    value: 'substitution',
    align: 'left',
  },
  {
    text: 'Stream',
    value: 'stream',
    align: 'left',
    sortable: true
  },
  {
    text: 'Size',
    value: 'size',
    align: 'left',
    sortable: true
  },
  {
    text: 'Comment',
    value: 'comment',
    align: 'left'
  }
];

export default {
  name: 'overview',
  components: {
    ShipLabel,
    DriverLabel,
    OrderDetails,
    BoxOverview
  },
  data() {
    return {
      pack: false,
      view: 'list',
      date: undefined,
      menu: false,
      toggle_exclusive: 0,
      selectedItem: 0,
      loading: false,
      moment: moment,
      search: '',
      dayIndex: 0,
      values: [],
      selected: [],
      headers: [],
      showLabels: false
    }
  },
  component: {
    OrderDetails: OrderDetails
  },
  mounted() {
    const date = moment(this.$route.query.date || moment().toISOString());
    if ([0, 2, 4, 6].indexOf(date.day()) > -1) {
      this.date = moment().add(-1, 'days').toISOString();
    } else {
      this.date = date.toISOString();
    }
    return this.initOrders();
  },
  methods: {
    allowedDates: val => [1, 3, 5].includes(moment(val).day()),
    initOrders: async function () {
      try {
        this.loading = true;
        const date = moment(this.date);
        this.setHeaders();
        // console.log('date,',date.toISOString());
        const dateString = moment(date).format(moment.HTML5_FMT.DATE);
        await this.$store.dispatch('initOrders', date);
        if (this.$route.query.date !== dateString) {
          this.$router.replace({query: {date: dateString}});
        }
        this.loading = false;
      } catch (e) {
        console.log(e.message, e);
        window.alert('something went wrong, you should reload this page')
        this.loading = false;
      }
    },
    setHeaders() {
      this.headers = [];
      this.headers = JSON.parse(JSON.stringify(headerBase));
      for (const day of this.daysGroup) {
        this.headers.push({
          text: `Breakfast<br />${day}`,
          value: `b_${day}`,
          align: 'center',
          sortable: false
        });
        this.headers.push({
          text: `Lunch<br />${day}`,
          value: `l_${day}`,
          align: 'center',
          sortable: false
        });
        this.headers.push({
          text: `Dinner<br />${day}`,
          value: `d_${day}`,
          align: 'center',
          sortable: false
        });
        this.headers.push({
          text: `Custom<br />${day}`,
          value: `c_${day}`,
          align: 'center',
          sortable: false
        });
      }
      this.headers.push({
        text: `Packed`,
        value: 'packed',
        align: 'center',
        sortable: false
      });
    },
    getCompanyName: function (id) {
      for (let key in this.companies) {
        if (this.companies[key].id === id) {
          return this.companies[key].name;
        }
      }
      return id || '';
    },
    updatePack: function (packed) {
      this.pack = packed;
    },
    packedMeals: function (item, val) {
      let db = firebase.database();
      db.ref(`orders/${this.week}/${item.uid}/packed/${this.day}`).set(val);
    },
    formatDate(date) {
      return moment(date).format("ddd, MMM D");
    },
    formatShippingDate() {
      const dateString = this.formatDate(this.shippingDate);
      //console.log('this.day',this.day);
      if (this.day === 'mon') {
        const dateTomorrowString = this.formatDate(moment(this.shippingDate).add(1, 'day'));
        return `${dateString} & ${dateTomorrowString}`;
      } else {
        return dateString;
      }
    },
    parseDate: function (date) {
      let firstDay = moment(date).format("ddd, MMM D");
      let secondDay = moment(date).add(1, 'day').format("ddd, MMM D");
      return `${firstDay} - ${secondDay}`;
    },
    isMealOrdered: function (item, meal) {
      if (item.day[moment(this.date).day() - 1]) {
        return item.day[moment(this.date).day() - 1][meal] === 1;
      }
      return false;
    },
    getNext: function () {
      const inc = this.day === 'fri' ? 3 : 2;
      let date = moment(this.date).add(inc, "days").toISOString();
      this.date = date;
      this.$nextTick(() => {
        this.initOrders();
      });
    },
    getPrevious: function () {
      const inc = this.day === 'mon' ? -3 : -2;
      let date = moment(this.date).add(inc, "days").toISOString();
      this.date = date;
      this.$nextTick(() => {
        this.initOrders();
      });
    },
    displayFilteredItems: function (index) {
      this.showDetails = true;
      this.view = 'details';
      this.selectedItem = index;
    },
    getDayIndex: function () {
      return moment(this.date).day() - 1;
    },
    getFullQuantity: function (meals, tod) {
      let quantity = 0
      if (meals && meals.length > 0) {
        let filteredMeals = meals.filter(item => item.tod === tod && item.order_type === 'full');
        for (const meal of filteredMeals) {
          if (meal.quantity) {
            quantity += meal.quantity;
          }
        }
      }
      return quantity;
    },
    getCustomQuantity: function (meals) {
      let quantity = 0;
      if (meals && meals.length > 0) {
        for (let meal of meals) {
          if (meal.quantity) {
            quantity += meal.quantity;
          }
        }
      }
      return quantity;
    },
    getCustomOrders: function (meals) {
      let orders = [];
      if (meals && meals.length > 0) {
        let filteredMeals = meals.filter(item => item.order_type === 'custom' || item.order_type === 'chefs_choice');
        for (let meal of filteredMeals) {
          if (meal.quantity) {
            orders.push(meal);
          }
        }
      }
      return orders;
    },
    getFullDay: function (day) {
      return moment().day(day).format('dddd');
    },
    logout: function () {
      firebase.auth().signOut().then(() => {
        window.location.replace('/#/login');
      });
    },
    formatDriver(name) {
      const nameWords = (name || '').split(' ');
      return nameWords.map(word => word[0]).join('');
    },
    // getShippingDay({location}) {
    //   const shipDay = this.shipDay;
    //   // office deliveries are made during business days, but prepped for shipping
    //   // w/ sunday orders, so a sunday delivery is actually shipped on monday
    //   console.log('location', location);
    //   if (shipDay === 'sun' && location && (location.toLowerCase() === 'Company')) {
    //     console.log('biz ship day for ', user.last_name);
    //     return 'mon';
    //   } else {
    //     return shipDay;
    //   }
    // },
    getDriver({shipDay, order}) {
      const driver = (order.logistics && order.logistics[shipDay] && order.logistics[shipDay].driver) || '';
      if (!driver && shipDay === 'sun') {
        return this.getDriver({shipDay: 'mon', order});
      } else
        return driver;
    }
  },
  computed: {
    ...mapGetters({
      'companies': 'getCompanies',
      'orders': 'getOrders',
      'users': 'getUsers',
      'substitutions': 'getSubstitutions',
      'plans': 'getPlans',
      'streamsArray': 'getStreams'
    }),
    shippingDate() {
      const shipMap = {
        // 0: 0,
        1: 0,
        2: 0,
        3: 2,
        4: 2,
        5: 4,
        6: 4
      }
      const date = moment(this.date);
      const day = date.day();
      if (shipMap[day] !== undefined) {
        return date.clone().day(shipMap[day]);
      } else {
        window.alert('this day (' + day + ') does not have a specified shipping date');
      }
    },
    streams() {
      const streams = {};
      for (const stream of this.streamsArray) {
        streams[stream.id] = stream;
      }
      return streams;
    },
    week() {
      let date = moment(this.date).day(5);
      // let week = date.year() + "_" + date.week();
      let week = date.format('gggg_w');
      return week;
    },
    day() {
      return moment(this.date).format('ddd').toLowerCase();
    },
    shipDay() {
      return moment(this.shippingDate).format('ddd').toLowerCase();
    },
    items() {
      let items = [];
      let date = moment(this.date);
      // let week = date.year() + "_" + date.week();
      let week = date.format('gggg_w');
      for (let key in this.orders[week]) {
        this.orders[week][key].company = this.getCompanyName(this.orders[week][key].company);
        items.push(this.orders[week][key]);
      }
      return items;
    },
    daysGroup() {
      const groups = {
        "mon": ["mon", "tue"],
        "tue": ["mon", "tue"],
        "wed": ["wed", "thu"],
        "thu": ["wed", "thu"],
        "fri": ["fri", "sat"],
        "sat": ["fri", "sat"]
      };
      return groups[this.day];
    },
    newItems() {
      let items = [];
      // console.log('newItems week',this.week);
      // console.log('newItems orders',this.orders[this.week]);
      for (let uid in this.orders[this.week]) {
        let data = {
          "mon": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "tue": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "wed": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "thu": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "fri": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "sat": {breakfast: 0, lunch: 0, dinner: 0, custom: []},
          "sun": {breakfast: 0, lunch: 0, dinner: 0, custom: []}
        };
        let user = this.users[uid];
        if (user) {
          data.uid = uid;
          data.name = `${user.first_name} ${user.last_name}`;
          const order = this.orders[this.week][uid];
          data.packed = order.packed ? order.packed[this.day] || false : false;
          data.location = user.location || (user.company ? 'Company' : 'Home');
          data.driver = this.getDriver({shipDay: this.shipDay, order});
          data.comment = user.comment;
          data.size = user.meal_size || 'medium';
          data.stream = this.plans[user.plan].stream;
          data.company = this.getCompanyName(user.company);

          for (let day of this.daysGroup) {
            let orders = order.meals ? order.meals[day] : null;
            if (!user || !orders || (user.is_active === false && !user.show_meals)) {
              continue;
            }
            let dayOrder = data[day];
            dayOrder.breakfast += this.getFullQuantity(orders, 'breakfast');
            dayOrder.lunch += this.getFullQuantity(orders, 'lunch');
            dayOrder.dinner += this.getFullQuantity(orders, 'dinner');
            dayOrder.custom = [...dayOrder.custom, ...this.getCustomOrders(orders)];

            if ((dayOrder.breakfast > 0 || dayOrder.lunch > 0 || dayOrder.dinner > 0 || dayOrder.custom.length > 0) && items[items.length - 1] !== data) {
              data.bags = OrderHelper.getNumberOfBags(order, this.daysGroup, user.meal_size, data.stream);
              data.bagSize = OrderHelper.getSizeOfBags(order, this.daysGroup, user.meal_size, data.stream);
              data.bins = OrderHelper.getBins(order, this.daysGroup);
              items.push(data);
            }
          }

          if (user.allergies && !(user.allergies.length === 1 && user.allergies[0] === '')) {
            for (let allergy of user.allergies) {
              if (allergy !== '' && this.substitutions[allergy]) {
                data.substitution = data.substitution ? data.substitution + ', ' + this.substitutions[allergy].text : this.substitutions[allergy].text;
              }
            }
            data.substitutions = user.allergies;
          }
        }
      }
      items.sort((a, b) => {
        if (a.driver !== b.driver) {
          return a.driver.localeCompare(b.driver);
        }
        return a.name.localeCompare(b.name);
      });
      return items;
    },
    usersCountPerDay() {
      let total = {};
      for (const day of this.daysGroup) {
        total[day] = total[day] || {};
        for (const item of this.newItems) {
          const orderItem = item[day];
          if (orderItem && (orderItem.breakfast > 0 || orderItem.lunch > 0 || orderItem.dinner > 0 || orderItem.custom.length > 0)) {
            total[day][item.stream] = total[day][item.stream] || 0;
            total[day][item.stream]++;
          }
        }
      }
      return total;
    },
    sheets() {
      let sheets = [];
      for (const item of this.newItems) {
        for (let i = 0; i < item.bags; i++) {
          let label = {
            ...item
          };
          if (item.bags > 1) {
            label.bags = `${i + 1}/${item.bags}`;
          }
          sheets.push(label);
        }
      }
      // sheets.sort((first, second) => {
      //   if (first.name < second.name) {
      //     return -1;
      //   }
      //   if (first.name > second.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      return sheets;
    },
    filteredItems() {
      return this.items.filter(item => {
        for (let key in item) {
          if (key.indexOf("_") === 3 && moment().day(key).day() - 1 === this.getDayIndex()) {
            if (item[key] === 1) {
              return true;
            }
          }
        }
        return false;
      });
    },
    assignedDriverCount() {
      return this.newItems.reduce((sum, item) => sum + (item.driver ? 1 : 0), 0);
    },
    drivers() {
      const drivers = {};
      this.newItems.forEach(item => {
        if (item.driver) {
          drivers[item.driver] = drivers[item.driver] || 0;
          drivers[item.driver]++;
        }
      });
      return drivers
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
#overview {
  table {
    td {
      font-weight: 400;
      font-size: 17px !important;
    }

    th {
      font-size: 15px !important;
    }
  }

  .badge__badge {
    height: 16px;
    width: 16px;
    font-size: 11px;
    font-weight: bold;
  }
}

.printOnly {
  display: none;
}

@media print {
  //  @page {
  //    size: landscape;
  //    margin-top: 1.047cm;
  //    margin-bottom: 0;
  //  }

  .printOnly {
    display: inline;
    font-family: 'Gotham Bold';
  }

  .dontPrint {
    display: none;
  }
  //
  //  #overview {
  //    display: none;
  //  }
  //  .page-break {
  //    page-break-after: always;
  //  }
}
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue